import React, { useMemo } from "react";
import { useLinked } from "@type-r/react";
import Papa from "papaparse";
import { getAuthorizationBearer } from "../../api/endpoint";
import { div, Loading } from "lqx-react";
import moment from "moment";
import { DataSheet } from "../data-sheet";
import { appConfig } from "../../api/appConfig";


const buildSheet = (sheet: any, dateFormat: string, csvPreviewRowsLimit : any) => {
    const rows = csvPreviewRowsLimit + 1;
    return sheet.slice(0, rows).map((row: any) =>
        row.map((cell: any) => {
            const date = moment(cell, [ dateFormat ], true);
            return date.isValid() ? moment(cell).format(dateFormat) : cell;
        })
    )
};

export const CsvViewer = ({ url, $scale }: { url: string, $scale }) => {
    const $data = useLinked([]);
    const $isReady = useLinked(false);
    const $desiredDateFormat = useLinked("MM/dd/yyyy");
    const fontSize = useMemo(() => 10 + $scale.value, [ $scale.value ]);

    useMemo(() => {
        Papa.parse(url, {
            download: true,
            downloadRequestHeaders: {
                authorization: getAuthorizationBearer()
            },
            header: false,
            dynamicTyping: true,
            complete: file => {
                $data.set(buildSheet(file.data, $desiredDateFormat.value, appConfig.csvPreviewRowsLimit ));
                $isReady.set(true);
            }
        });
    }, [ true ]);

    return $isReady.value ?
        <DataSheetContainer>
            <DataSheet data={ $data.value } fontSize={ fontSize } />
        </DataSheetContainer>
        : <Loading />
}

const DataSheetContainer = div({
    height: '100%'
});
